import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games for 20% off, add 3 games for an exclusive batting practice viewing opportunity from the field, add 4 games for 30% off, or add 5+ games for 40% off your tickets.",
  progressBarAditionalText: " for 20% off your tickets!",
};

function GwinnettStripersLink() {
  return (
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://am.ticketmaster.com/gwinnettstripers/"
    >
      Account Manager
    </Link>
  );
}

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Gwinnett Stripers account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <GwinnettStripersLink /> within 24
        hours. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Get Hooked Flex Program work?",
    description: (
      <>
        The Get Hooked Flex Program allows fans to select any seat to select
        games hosted by the Stripers. The more games you select the higher your
        price discount! Simply log into your Gwinnett Stripers{" "}
        <GwinnettStripersLink /> and select games.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Gwinnett Stripers{" "}
        <GwinnettStripersLink /> Account.
      </>
    ),
  },
  {
    title:
      "How do I receive more information about the batting practice experience?",
    description: (
      <>
        The Gwinnett Stripers Box Office team will work with you to ensure you
        are set up for your batting practice experience if you qualify! We will
        be in touch after your purchase and can be reached at{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="tel:(678) 277-0340"
        >
          (678) 277-0340
        </Link>
        .
      </>
    ),
  },
];
